/* BROEK October UX corrections layered on top of the existing cart engine. */
(() => {
  'use strict';
  if (window.BroekSuggestionLayer) return;

  const root = window.Shopify?.routes?.root || '/';
  const requestFetch = window.fetch.bind(window);
  let pickerBusy = false;
  let replaceTarget = null;
  let urlTimer = 0;
  let lastUrl = location.href;

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const money = (cents) => `${(Math.max(0, Number(cents) || 0) / 100).toLocaleString('en-EG', {
    minimumFractionDigits: cents % 100 ? 2 : 0,
    maximumFractionDigits: 2
  })} EGP`;
  const getState = () => window.BroekClaudeUI?.getState?.() || {
    paid: 0, free: 0, applied: 0, freeSavings: 0, tier: 0, lines: []
  };
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  function toast(message, tone = 'info') {
    let stack = document.querySelector('[data-bc-toast-stack]');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'bc-toast-stack';
      stack.dataset.bcToastStack = '';
      stack.setAttribute('aria-live', 'polite');
      document.body.append(stack);
    }
    const item = document.createElement('div');
    item.className = `bc-toast bc-toast--${tone}`;
    item.setAttribute('role', tone === 'error' ? 'alert' : 'status');
    const text = document.createElement('p');
    text.textContent = message;
    const close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Dismiss message');
    close.textContent = '×';
    close.addEventListener('click', () => item.remove());
    item.append(text, close);
    stack.append(item);
    window.setTimeout(() => item.remove(), tone === 'error' ? 9000 : 6500);
  }

  function showFormError(form, message) {
    const error = form.querySelector('.broek-picker-error');
    if (error) error.textContent = message;
    else toast(message, 'error');
  }

  function sectionContext() {
    const fullSection = document.querySelector('#main-cart-items')?.closest('.shopify-section');
    const fullId = fullSection?.id?.replace(/^shopify-section-/, '') || '';
    const ids = ['minicart-form'];
    if (fullId) ids.push(fullId);
    return { fullSection, fullId, ids };
  }

  function applySections(sections, context) {
    if (!sections) return;
    const miniHtml = sections['minicart-form'];
    if (miniHtml) {
      const next = parse(miniHtml).querySelector('#minicart-form');
      const current = document.querySelector('#minicart-form');
      if (next && current) current.replaceWith(next);
    }
    if (context.fullId && sections[context.fullId]) {
      const documentFragment = parse(sections[context.fullId]);
      const nextMain = documentFragment.querySelector('#main-cart-items');
      const currentMain = document.querySelector('#main-cart-items');
      if (nextMain && currentMain) currentMain.replaceWith(nextMain);
      else if (context.fullSection) {
        const nextSection = documentFragment.querySelector(`#${CSS.escape(context.fullSection.id)}`);
        if (nextSection) context.fullSection.innerHTML = nextSection.innerHTML;
      }
    }
    const drawer = document.querySelector('#minicart_wrapper');
    if (typeof drawer?.cartAction === 'function') drawer.cartAction();
  }

  async function fetchJson(url, options) {
    const response = await requestFetch(url, options);
    let data;
    try {
      data = await response.json();
    } catch (_) {
      throw new Error('The bag returned an unreadable response.');
    }
    if (!response.ok || data?.status) {
      throw new Error(data?.description || data?.message || 'The bag could not be updated.');
    }
    return data;
  }

  async function addVariant(variantId, context, role) {
    const item = { id: Number(variantId), quantity: 1 };
    if (role === 'free') {
      item.properties = { _broek_free_pick_selection: String(Date.now()) };
    }
    return fetchJson(`${root}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [item],
        sections: context.ids,
        sections_url: `${location.pathname}${location.search}`
      })
    });
  }

  async function changeLine(key, quantity, context) {
    return fetchJson(`${root}cart/change.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity,
        sections: context.ids,
        sections_url: `${location.pathname}${location.search}`
      })
    });
  }

  async function refreshState() {
    for (let attempt = 0; attempt < 25 && !window.BroekClaudeUI?.refresh; attempt += 1) {
      await sleep(40);
    }
    if (window.BroekClaudeUI?.refresh) await window.BroekClaudeUI.refresh();
    return getState();
  }

  function actualFreeLines(state) {
    return (state.lines || []).filter((line) => line.lane === 'free' && Number(line.freeUnits) > 0);
  }

  function announceFreeResult(state, selectedKey, selectedTitle, selectedUnit, replacing) {
    const selected = selectedKey
      ? (state.lines || []).find((line) => line.key === selectedKey && line.lane === 'free')
      : null;
    const selectedFreeUnits = Number(selected?.freeUnits || 0);
    if (selectedFreeUnits > 0) {
      toast(
        `${replacing ? 'Free Gift updated.' : 'Free Gift applied.'} ${selectedTitle} is shown at 0 EGP in your bag.`,
        'success'
      );
      return;
    }

    const actual = actualFreeLines(state)[0];
    if (actual) {
      toast(
        `${selectedTitle} was added at its displayed price. The free discount is currently applied to ${actual.title || 'another Free Gift option'}.`,
        'warning'
      );
      return;
    }

    const verificationNote = selectedKey ? '' : ' The exact added line could not be verified.';
    toast(
      `${selectedTitle} was added at ${money(selectedUnit)}. No Free Gift discount is currently applied.${verificationNote}`,
      'warning'
    );
  }

  function setPickerBusy(form, active) {
    document.querySelectorAll('form[data-broek-offer-add] button[type="submit"]').forEach((button) => {
      if (active) {
        button.dataset.bcOriginalDisabled = String(button.disabled);
        button.disabled = true;
        button.textContent = 'UPDATING BAG…';
      } else {
        button.disabled = button.dataset.bcOriginalDisabled === 'true';
        delete button.dataset.bcOriginalDisabled;
        button.textContent = button.dataset.bcSubmitLabel || 'ADD TO BAG';
      }
    });
    form.setAttribute('aria-busy', String(active));
  }

  function confirmFreeAdd(state, role, target) {
    if (role !== 'free' || target) return true;
    const entitlement = Math.floor((Number(state.paid) || 0) / 2);
    if (entitlement === 0) {
      return window.confirm(
        "You haven't unlocked a Free Gift yet. This item will be added at its displayed price. Continue?"
      );
    }
    if ((Number(state.applied) || 0) >= entitlement) {
      return window.confirm(
        'All unlocked Free Gifts are already applied. This item may remain at its displayed price, and Shopify can reallocate which eligible line is free. Continue?'
      );
    }
    return true;
  }

  async function handlePickerSubmit(event) {
    const form = event.target.closest?.('form[data-broek-offer-add]');
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (pickerBusy) return;
    if (!form.reportValidity()) return;

    const select = form.querySelector('select[name="id"]');
    const option = select?.selectedOptions?.[0];
    const variantId = select?.value;
    const role = form.dataset.bcPickerRole || form.closest('[data-broek-picker-role]')?.dataset.broekPickerRole || '';
    const title = form.dataset.bcProductTitle || form.closest('[data-bc-product-title]')?.dataset.bcProductTitle || 'This item';
    const unitPrice = Number(option?.dataset.price || form.closest('[data-bc-unit-price]')?.dataset.bcUnitPrice || 0);
    const stateBefore = getState();
    const target = role === 'free' ? replaceTarget : null;
    replaceTarget = null;

    if (!variantId) {
      form.reportValidity();
      return;
    }

    if (target) {
      const currentTarget = (stateBefore.lines || []).find(
        (line) => line.key === target.key && line.lane === 'free' && Number(line.freeUnits) > 0
      );
      if (!currentTarget) {
        showFormError(form, 'This Free Gift changed in your bag. Close this window and try again.');
        return;
      }
      target.quantity = Number(currentTarget.quantity || target.quantity || 1);
      target.variant = currentTarget.variant || target.variant;
      target.title = currentTarget.title || target.title;
    }

    if (target && String(target.variant) === String(variantId)) {
      replaceTarget = target;
      showFormError(form, 'This size is already selected as your Free Gift. Choose a different item or size.');
      return;
    }

    if (!confirmFreeAdd(stateBefore, role, target)) return;

    pickerBusy = true;
    setPickerBusy(form, true);
    showFormError(form, '');
    document.dispatchEvent(new CustomEvent('broek:cart-mutation-start'));

    const context = sectionContext();
    let finalResult;
    let addedKey = '';

    try {
      const addResult = await addVariant(variantId, context, role);
      finalResult = addResult;
      addedKey = addResult?.items?.[0]?.key || addResult?.key || '';

      if (target) {
        const quantity = Math.max(0, Number(target.quantity || 1) - 1);
        try {
          finalResult = await changeLine(target.key, quantity, context);
        } catch (replaceError) {
          if (!addedKey) {
            toast('The replacement could not be rolled back automatically. Review your bag before checkout.', 'error');
            location.assign(`${root}cart`);
            return;
          }
          try {
            const rollbackResult = await changeLine(addedKey, 0, context);
            applySections(rollbackResult.sections, context);
            await refreshState();
          } catch (_) {
            toast('The replacement could not be completed safely. Review your bag before checkout.', 'error');
            location.assign(`${root}cart`);
            return;
          }
          throw new Error('The replacement was not completed. Your original Free Gift was kept.');
        }
      }

      applySections(finalResult.sections, context);
      form.closest('dialog')?.close();
      const finalState = await refreshState();
      announceFreeResult(finalState, addedKey, title, unitPrice, Boolean(target));
      window.dispatchEvent(new CustomEvent('broek:cart-drawer-refreshed', { detail: finalResult }));

      const drawer = document.querySelector('#minicart_wrapper');
      if (typeof drawer?.open === 'function') drawer.open();
    } catch (error) {
      showFormError(form, error.message || 'The bag could not be updated.');
      toast(error.message || 'The bag could not be updated.', 'error');
      replaceTarget = target;
      await refreshState();
    } finally {
      pickerBusy = false;
      setPickerBusy(form, false);
      document.dispatchEvent(new CustomEvent('broek:cart-mutation-end'));
    }
  }

  function rememberReplacement(event) {
    const replace = event.target.closest?.('[data-bc-replace-free]');
    const normalFreeOpener = event.target.closest?.('[data-broek-open-picker="free"]');

    if (replace) {
      const stateLine = (getState().lines || []).find((line) => line.key === replace.dataset.bcLineKey);
      replaceTarget = {
        key: replace.dataset.bcLineKey,
        quantity: Number(replace.dataset.bcQuantity || stateLine?.quantity || 1),
        variant: replace.dataset.bcVariant || stateLine?.variant,
        title: replace.dataset.bcTitle || stateLine?.title || 'Free Gift'
      };
      return;
    }
    if (normalFreeOpener) replaceTarget = null;
  }

  function polishPicker(scope = document) {
    const dialogs = [];
    if (scope.matches?.('.broek-picker-dialog')) dialogs.push(scope);
    scope.querySelectorAll?.('.broek-picker-dialog').forEach((dialog) => dialogs.push(dialog));
    const owner = scope.closest?.('.broek-picker-dialog');
    if (owner) dialogs.push(owner);

    [...new Set(dialogs)].forEach((dialog) => {
      const isFree = Boolean(dialog.querySelector(
        '[data-broek-picker-collection="october-free-picks"], [data-broek-picker-view][href*="/october-free-picks"], [data-broek-picker-role="free"]'
      ));
      const isPaid = Boolean(dialog.querySelector(
        '[data-broek-picker-collection="october-paid-items"], [data-broek-picker-view][href*="/october-paid-items"], [data-broek-picker-role="paid"]'
      ));
      if (!isFree && !isPaid) return;
      const role = isFree ? 'free' : 'paid';
      if (dialog.dataset.bcPolished === role) return;
      dialog.dataset.bcPolished = role;
      const heading = dialog.querySelector('.broek-picker-header h2');
      const description = dialog.querySelector('.broek-picker-header p');
      let pickerCopy = {};
      try { pickerCopy = JSON.parse(document.querySelector('[data-bo-copy]')?.textContent || '{}'); } catch (_) {}
      if (isFree) {
        dialog.dataset.bcReplacementFlow = replaceTarget ? 'true' : 'false';
        if (!dialog.dataset.bcReplacementBound) {
          dialog.dataset.bcReplacementBound = 'true';
          dialog.addEventListener('close', () => {
            if (dialog.dataset.bcReplacementFlow === 'true') replaceTarget = null;
          });
        }
        if (heading) heading.textContent = replaceTarget ? 'REPLACE YOUR FREE GIFT' : 'CHOOSE YOUR FREE GIFT';
        if (description && pickerCopy.giftPickerNote) description.textContent = pickerCopy.giftPickerNote;
      } else {
        if (heading) heading.textContent = 'SHOP JEANS & VESTS';
        if (description && pickerCopy.paidPickerNote) description.textContent = pickerCopy.paidPickerNote;
      }
    });
  }

  function polishProductCards(scope = document) {
    const cards = new Set();
    if (scope.matches?.('.product-item')) cards.add(scope);
    scope.querySelectorAll?.('.product-item').forEach((card) => cards.add(card));
    const owner = scope.closest?.('.product-item');
    if (owner) cards.add(owner);

    cards.forEach((card) => {
      const campaignBadge = card.querySelector('.broek-offer-badge:not([hidden])');
      card.querySelectorAll('.product__badges').forEach((badges) => {
        badges.hidden = Boolean(campaignBadge);
      });
      const lane = card.querySelector('[data-broek-oct-lane]')?.dataset.broekOctLane;
      if (lane !== 'paid' || !campaignBadge) {
        card.querySelector('.broek-card-program-note')?.remove();
      }
    });
  }

  function normalizeSaleLinks(scope = document) {
    scope.querySelectorAll?.('a[href]').forEach((anchor) => {
      if (anchor.closest('.facets, .active-facets, .filter-current, .collection-toolbar')) return;
      try {
        const url = new URL(anchor.href, location.origin);
        if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== '/collections/last-sizes-final-pieces') return;
        if (!url.searchParams.has('filter.v.availability')) {
          url.searchParams.set('filter.v.availability', '1');
          anchor.href = `${url.pathname}${url.search}${url.hash}`;
        }
      } catch (_) {}
    });
  }

  function requestFilterRefresh() {
    clearTimeout(urlTimer);
    urlTimer = window.setTimeout(async () => {
      if (location.href === lastUrl) return;
      lastUrl = location.href;
      await refreshState();
      normalizeSaleLinks();
    }, 180);
  }

  function patchHistory() {
    ['pushState', 'replaceState'].forEach((method) => {
      const original = history[method];
      if (original.__bcPatched) return;
      const patched = function (...args) {
        const result = original.apply(this, args);
        window.dispatchEvent(new Event('bc:locationchange'));
        return result;
      };
      patched.__bcPatched = true;
      history[method] = patched;
    });
    window.addEventListener('popstate', () => window.dispatchEvent(new Event('bc:locationchange')));
    window.addEventListener('bc:locationchange', requestFilterRefresh);
  }

  function init() {
    normalizeSaleLinks();
    polishPicker();
    polishProductCards();
    patchHistory();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          polishPicker(node);
          polishProductCards(node);
          normalizeSaleLinks(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', rememberReplacement, true);
  document.addEventListener('submit', handlePickerSubmit, true);
  document.addEventListener('broek:offer-state', () => polishProductCards());
  document.addEventListener('shopify:section:load', () => polishProductCards());

  window.BroekSuggestionLayer = {
    version: '2026.09.26.4',
    getReplacement: () => replaceTarget
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();



